import styled from 'styled-components'
import ButtonView from 'components/button/ButtonView'

const getFontBoldFamily = props => props.theme.buttons.text.boldFamily

const StyledButtonView = styled(ButtonView)`
  font-family: ${getFontBoldFamily};
`

export default StyledButtonView
